import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import CookieConsentBanner from "./components/feature/CookieConsentBanner";
import BeaaMascotButton from "./pages/goiania/components/beaa/BeaaMascotButton";
import { resolverRespostaPortal } from "./utils/beaaManualPortal";

function App() {
  // A indexação dos manuais da Beaa é feita pelo Console (operador) e pelo gatilho do banco —
  // o navegador do visitante não dispara mais geração de embeddings.
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <CookieConsentBanner />
        <BeaaMascotButton resolver={resolverRespostaPortal} />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;